import { Box, Stack, Typography } from "@mui/material";
import React, { Suspense } from "react";
import { FileDownloadOutlined as DownloadTasks } from "@mui/icons-material";

import manageColumnIcon from "../../../../styles/svg/Vector.svg";
import OpenCardDetail from "../Kanban/openCardDetail";
import addIcon from "../../../../styles/svg/addIcon.svg";
import CreateCardDialogListview from "./CreateCardDialogListview";
import ChildTaskData from "./ChildTaskData";
import Loader from "../../../../components/Loader";
import { useResponsive } from "../../../../hooks/useResponsive";
import CustomMenu from "../../../../components/Menu";
import { CustomButton } from "../../../../components/Button/Button";
import "./ListView.scss";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import ColumnCheckboxes from "./ColumnCheckboxes";
import { generateCSVData } from "../../../../utils/csvUtils";
import { useBoardListViewState } from "./hooks/useBoardListViewState";

const GlobalTableComponent = React.lazy(() =>
  import("../../../../components/Table/Table/Table")
);

export default function ListView({
  workflowId,
  boardName,
  cards,
  isLoading,
  allCardsByBoard,
}) {
  const isMobile = useResponsive("down", "md");
  const [quickTasks, setQuickTasks] = useCustomSearchParams("quickTasks");
  const {
    anchorEl,
    boardCards,
    cardId,
    columns,
    expandcardId,
    handleColumOrder,
    handleExpandedData,
    handleSelectAll,
    handleSelectColumn,
    isSubtaskLoading,
    isMilestoneSelected,
    open,
    openCreateCard,
    rows,
    setAnchorEl,
    setIsSubtaskLoading,
    setOpenCreateCard,
    setSubtaskCards,
    workflowSteps,
  } = useBoardListViewState({
    workflowId,
    boardName,
    cards,
  });

  const loader = {
    style: { color: "black" || "#ffffff" },
    size: 20,
  };

  const subTableProps = {
    isCollapsible: true,
    isHiddenRowExpandIcon: true,
    isHeaderHidden: true,
    isLoading: isSubtaskLoading,
    loadingProps: loader,
  };

  const handleGenerateCSVData = () => {
    generateCSVData(
      boardCards,
      allCardsByBoard,
      workflowSteps,
      columns,
      boardName
    );
  };

  return (
    <>
      {expandcardId && (
        <ChildTaskData
          cardId={expandcardId}
          setSubtaskCards={setSubtaskCards}
          setIsSubtaskLoading={setIsSubtaskLoading}
        />
      )}
      {boardCards && cardId && <OpenCardDetail cardsOnBoard={boardCards} />}
      {openCreateCard && workflowSteps.length > 0 && (
        <CreateCardDialogListview
          open={openCreateCard}
          handleClose={() => setOpenCreateCard(false)}
          workflowSteps={workflowSteps}
        />
      )}
      <div>
        <Stack
          direction="row"
          className="d-flex justify-content-end align-items-center"
          mb={3}
        >
          <Stack
            direction="row"
            justifyContent="end"
            onClick={(event) => setAnchorEl(event.currentTarget)}
          >
            <img
              src={manageColumnIcon}
              width={14}
              alt="manage column"
              style={{ cursor: "pointer" }}
            />
            <Typography className="manage-board">Manage Columns</Typography>
          </Stack>
          <CustomButton
            className=" white-button capitalize ml-1"
            sx={{
              height: "38px",
              "&:hover": {
                outline: "none",
                backgroundColor: "rgb(240 249 254)",
                border: "1px solid #1b3e61",
              },
            }}
            variant="outlined"
          >
            <label className="custom-checkbox">
              <input
                type="checkbox"
                checked={!quickTasks}
                onClick={() =>
                  setQuickTasks(
                    "quickTasks",
                    quickTasks === "false" ? "" : "false"
                  )
                }
              />
              <span className="checkmark"></span>
              Include quick tasks
            </label>
          </CustomButton>
          <CustomButton
            onClick={() => setOpenCreateCard(true)}
            className="theme-bg-color capitalize ml-3 listview-create-card-button"
            variant="contained"
            startIcon={<img src={addIcon} alt="addSubtaskIcone" />}
          >
            Create Card
          </CustomButton>
          <CustomButton
            onClick={handleGenerateCSVData}
            className="secondary-background-color capitalize ml-3 download-missing-status"
            variant="contained"
            color={"warning"}
            startIcon={<DownloadTasks />}
          >
            {!isMobile ? "Download" : ""}
          </CustomButton>
        </Stack>
        <Box>
          <Suspense
            fallback={
              <div className="loader-center">
                <Loader color={"black"} />
              </div>
            }
          >
            <GlobalTableComponent
              data={rows}
              headers={columns}
              subHeader={columns.map((item, index) =>
                index === 0
                  ? {
                      ...item,
                      alignContent: "center",
                    }
                  : item
              )}
              isCollapsible={true}
              isDraggableColumn={true}
              isPagination={false}
              rowCount={10}
              handleExpandedData={handleExpandedData}
              subTableProps={subTableProps}
              tableBoxClass={
                isMilestoneSelected
                  ? "parent-milestone-table-box"
                  : "parent-table-box"
              }
              tableContainerClass={"parent-table-boarder"}
              isLoading={isLoading}
              loadingProps={loader}
              loadingClass={"h-70vh"}
              headerClass={"table-header-listview"}
              handleColumOrder={handleColumOrder}
              defaultSortBy={"is_todo"}
              rowClassName={(row) => (row.is_todo ? "todo-row" : "")}
            />
          </Suspense>
        </Box>
        <CustomMenu
          id="user-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
          className="assign-board-owner-list"
        >
          <ColumnCheckboxes
            columns={columns}
            handleSelectAll={handleSelectAll}
            handleSelectColumn={handleSelectColumn}
          />
        </CustomMenu>
      </div>
    </>
  );
}
